import { render, staticRenderFns } from "./EventsEditLaboratories.vue?vue&type=template&id=e4b5e364&"
import script from "./EventsEditLaboratories.vue?vue&type=script&lang=js&"
export * from "./EventsEditLaboratories.vue?vue&type=script&lang=js&"
import style0 from "./EventsEditLaboratories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports